<template>
  <div class="h-450">
    <b-card class="mt-7">
      <b-row class="match-height">
        <b-col md="12" class="mb-2 flex">
          <!-- TODO: move component filters -->
          <b-row>
            <b-col cols="12" lg="1" class="d-flex align-items-center mb-1">
              <b-dropdown
                variant="flat-secondary"
                class="avenir-medium mr-1 show-dropdown-views"
              >
                <template #button-content>
                  <b-icon :icon="change_view_card ?'list-ol' : 'grid-fill'" font-scale="1.5" variant="dark" />
                </template>

                <b-dropdown-item @click="change_view_card = true">
                  <b-icon icon="list-ol" font-scale="1" variant="dark" class="mr-05"/>
                  {{$t('campaigns.viewList')}}
                </b-dropdown-item>
                <b-dropdown-item @click="change_view_card = false">
                  <b-icon icon="grid-fill" font-scale="1" variant="dark" class="mr-05"/>
                  {{$t('campaigns.viewCard')}}
                </b-dropdown-item>
              </b-dropdown>

              <b-button-group class="body-button-center hide-dropdown-views">
                <b-button
                  :class="change_view_card ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'"
                  :variant="change_view_card ? 'button-outline-header-grid-no-active' : 'button-outline-header-grid-active'"
                  @click="change_view_card = false"
                >
                  <b-icon icon="grid-fill" font-scale="1.5" variant="dark"></b-icon>
                </b-button>
                <b-button
                  :class="change_view_card ? 'button-outline-header-grid-active ml-05' : 'button-outline-header-grid-no-active ml-05'"
                  :variant="change_view_card ? 'button-outline-header-grid-active' : 'button-outline-header-grid-no-active'"
                  @click="change_view_card = true"
                >
                  <b-icon icon="list-ol" font-scale="1.5" variant="dark"></b-icon>
                </b-button>
              </b-button-group>
            </b-col>
            <b-col cols="12" lg="11" class="mb-1">
              <filters-dropdown
                :networks_avaibles="networks_avaibles"
                :actions_options="actions_options"
                :view_filters_status="true"
                :view_actions="true"
                :number_status="header_data"
                :view_sort="true"
                :sort_field="order_by_field"
                :sort_direction="order_by_direction"
                :sort_field_options="orderByFieldOptions"
                @filters-changed="onFiltersChanged"
                @action-selected="onActionSelected"
                @sort-changed="onSortChanged"
              />
            </b-col>
            <b-col>
            <div class="my-1 d-flex" v-if="checkedNames.length > 0">
              <span>{{$t('creator.selected_influencers_check')}}: {{checkedNames.length}}</span>
            </div>
            </b-col>
          </b-row>
        </b-col>
        <div class="w-100" :key="change_influencers" v-if="!change_view_card">
          <b-row class="w-100 m-0" v-if="influencers.length > 0" :key="change_influencers">
            <b-col v-for="(influencer, index) in influencers" :key="index" class=" col-12 col-sm-6 col-lg-4 col-xl-3">
              <!-- TODO: Remove prop style -->
              <b-card
                class="text-center card-all-users-profiles"
                style="box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1) !important"
                footer-class="without-border"
                :ref="`card-influencer-${influencer.uuid}`"
              >
                <div class="mb-1 position-relative">
                  <b-form-checkbox
                    v-model="checkedNames"
                    :value="influencer.uuid"
                    class="custom-control-primary"
                    :disabled="disabledUpdateCampaign()"
                  >
                  </b-form-checkbox>
                  <feather-icon
                    :id="`notes-${influencer.uuid}`"
                    icon="FileTextIcon"
                    size="16"
                    class="align-middle text-secondary position-absolute cursor-pointer notes-creator"
                    @click.stop="openNotes(influencer.uuid, influencer.influencer.name)"
                  />
                  <b-popover :target="`notes-${influencer.uuid}`" triggers="hover" placement="top">
                    {{ $t('campaigns.notes_popover') }}
                  </b-popover>
                  <feather-icon
                    @click="deletedCreator(influencer.uuid, influencer.influencer.username)"
                    icon="XIcon"
                    size="16"
                    class="align-middle text-secondary position-absolute cursor-pointer delete-creator"
                    :disabled="disabledUpdateCampaign()"
                  />
                </div>
                <div class="profile-image-wrapper mb-2">
                  <div class="profile-image p-0 position-relative">
                      <b-avatar class="socialnet-campaigns p-0" variant="light">
                        <b-img  :src="`${getIconWhite(influencer.influencer.network.toLowerCase())}`" :class="getIconColor(influencer.influencer.network.toLowerCase())" fluid></b-img>
                      </b-avatar>
                    <b-avatar
                      size="200"
                      variant="light-secondary"
                      :src="influencer.influencer.image_url"
                    >
                      <img class="img-200" :src="getImageInfluencer(influencer.influencer)" @error="replaceInsta($event, influencer.influencer.username, influencer.influencer.network)">
                    </b-avatar>
                  </div>
                </div>
                <b-link @click="openSummaryProfile(influencer.influencer)">
                  <h3>
                    {{ influencer.influencer.name }}
                    <image-verified v-if="influencer.influencer.is_verified" class="square-20"/>
                  </h3>
                  <h5 class="text-blue font-weight-bolder">
                  @{{ getUsername(influencer.influencer)}}
                </h5>
                </b-link>
                <h5 class="text-muted font-weight-bolder">
                  {{ $t(`influencerCategory.${influencer.influencer.calculate_category}`)}}
                </h5>

                <div :class="getClasses(influencer.influencer)">
                  <div v-if="influencer.influencer.followers > 0" class="mb-1 col-12 col-sm-6">
                    <h6 class="text-muted font-weight-bolder">
                      {{ $t('campaigns.followers') }}
                    </h6>
                    <h3 class="mb-0">
                      {{ engagement(influencer.influencer.followers) }}
                    </h3>
                  </div>
                  <div v-if="influencer.influencer.engagement_rate > 0" class="mb-1 col-12 col-sm-6">
                    <h6 class="text-muted font-weight-bolder">
                      {{ $t('campaigns.erTitle') }}
                    </h6>
                    <h3 class="mb-0">
                      {{ decimalFixed(influencer.influencer.engagement_rate, 2) }} %
                    </h3>
                  </div>
                </div>
                <template #footer>
                  <hr class="mb-2">
                  <StatusInfluencer @update_influencer="updateInfluencer" @updated_campaign="updated_campaign" :influencerStatus="influencer.status" :influencerUuid="influencer.uuid"></StatusInfluencer>
                </template>
              </b-card>
            </b-col>

            <div class="col-12 row m-0 p-0" v-if="loading_creators && (this.influencers.length <  this.total_results)">
              <b-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="i in 4" :key="i">
                <b-card class="card-skeleton">
                  <b-skeleton class="skeleton profile-avatar mb-2"></b-skeleton>
                  <b-skeleton class="skeleton h1 col-10"></b-skeleton>
                  <b-skeleton class="skeleton col-8 mb-5"></b-skeleton>

                  <b-skeleton class="skeleton col-4"></b-skeleton>
                  <b-skeleton class="skeleton col-4 mb-7"></b-skeleton>

                  <div class="d-flex w-100 mb-1">
                    <b-skeleton type="button" class="skeleton w-100 mr-2"></b-skeleton>
                    <b-skeleton type="button" class="skeleton w-100 ml-2"></b-skeleton>

                  </div>
                </b-card>
              </b-col>
            </div>
            <b-col class="col-12 text-center all-results-loaded-text" v-if="!loading_creators && influencers.length > 0 && influencers.length >= total_results">
              <feather-icon icon="CheckIcon" size="16" class="mr-50"/>
              <span>{{ $t('campaigns.allResultsLoaded') }}</span>
            </b-col>
          </b-row>
          <div v-else class="d-flex mb-2 align-items-center justify-content-center flex-column">
            <div class="col-12 row m-0 p-0" v-if="loading_creators">
              <b-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="i in 8" :key="i">
                <b-card class="card-skeleton">
                  <b-skeleton class="skeleton profile-avatar mb-2"></b-skeleton>
                  <b-skeleton class="skeleton h1 col-10"></b-skeleton>
                  <b-skeleton class="skeleton col-8 mb-5"></b-skeleton>
  
                  <b-skeleton class="skeleton col-4"></b-skeleton>
                  <b-skeleton class="skeleton col-4 mb-7"></b-skeleton>
  
                  <div class="d-flex w-100 mb-1">
                    <b-skeleton type="button" class="skeleton w-100 mr-2"></b-skeleton>
                    <b-skeleton type="button" class="skeleton w-100 ml-2"></b-skeleton>
  
                  </div>
                </b-card> 
              </b-col>
            </div>
            <img
              v-if="influencerStatusImage"
              :src="influencerStatusImage.src"
              class="w-50"
            />
            <no-Results
              :title= "$t('campaigns.influecersNotFound')"
              :show_button= "false"
              :no_border="true"
              v-else-if="status_influencers !== 'all' && status_influencers !== 'pending' && status_influencers !== 'approved' && status_influencers !== 'rejected'"
            />
            <b-button variant="outline-primary" pill @click="$emit('openSidebar')" :disabled="disabledUpdateCampaign()">{{ $t('campaigns.addInfluencer') }}</b-button>
          </div>
        </div>
        <div class="w-100 px-1" v-else>
          <div class="position-relative overflow-scroll">
            <vue-good-table
              :columns="$t('campaigns.tables.proposals_influencers')"
              :rows="influencers"
              :row-style-class="getRowClass"
              :select-options="{
                enabled: true,
                selectOnCheckboxOnly: false,
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true,
                selectAllByGroup: true,
              }"
              :selected-rows.sync="checkedNames"
              ref="my-table"
              @on-selected-rows-change="selectionChanged"
              :class="`${influencers.length > 0 ? 'vgt-table-influencers-inner-campaign' : ''} mt-1`"
              :key="update_table"
            >
              <div slot="emptystate">
                <no-Results
                  :title= "$t('campaigns.influecersNotFound')"
                  :show_button= "true"
                  :no_border="true"
                  :class_btn="'blue-button'"
                  :text_button="$t('campaigns.addInfluencer')"
                  :btn_action="openSidebarAddInfluencer"
                />
              </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'user'" class="text-nowrap row-selected-table">
                  <div class="d-flex p-1">
                    <b-avatar class="" variant="light" :src="getImageInfluencer(props.row.influencer)" @error="replaceInsta($event, props.row.influencer.username, props.row.influencer.network)" size="40">
                      <template #badge>
                        <b-avatar size="18px" class="avatar-absolute-net-influecer-list" variant="ligth">
                          <b-img :src="getIconWhite(props.row.influencer.network)" :class="getIconColor(props.row.influencer.network, false)" fluid/>
                        </b-avatar>
                      </template>
      
                    </b-avatar>
                    <div class="ml-1">
                      <b-link @click.stop="openSummaryProfile(props.row.influencer)">
                      <strong>{{ props.row.influencer.name }}</strong> </b-link><image-verified v-if="props.row.influencer.is_verified" class="ml-05"/>
                      <p class="mb-0 gray-color-text">@{{props.row.influencer.username}}</p>
                    </div>
                  </div>
                </span>
  
                <span v-if="props.column.field === 'type'" class="mr-1">
                  <b-badge variant="light-secondary">
                    {{ $t(`influencerCategory.${props.row.influencer.calculate_category}`) }}
                  </b-badge>
                </span>

                <span
                  v-if="props.column.field === 'network'"
                  class="text-center d-flex mr-1"
                >
                  <b-avatar variant="ligth" size="20" class="mr-05">
                    <b-img class="icon-squad-network-avatar" :src="getIconWhite(props.row.influencer.network)" :class="getIconColor(props.row.influencer.network, false)" fluid/>
                  </b-avatar>
                  <b-link @click.stop="openSummaryProfile(props.row.influencer)">
                  {{nameNetworks(props.row.influencer.network)}}
                  </b-link>
                </span>
  
                <span v-if="props.column.field === 'followers'">
                  <div v-if="props.row.influencer.followers > 0">{{ getFormat(props.row.influencer.followers) }}</div>
                </span>
      
                <span v-if="props.column.field === 'er'">
                  <div v-if="props.row.influencer.engagement_rate > 0">{{ props.row.influencer.engagement_rate.toFixed(2) }}%</div>
                  <span v-else>--</span>
                </span>
      
                <span v-if="props.column.field === 'actions'" class="d-flex align-items-center">
                  <div class="d-flex" v-if="props.row.status === 'pending'">
                    <b-button variant="flat-secondary" :id="`check-${props.index}`" @click.stop="actionTableStatus('approved', props.row.uuid)">
                      <feather-icon icon="CheckIcon" class="text-success"></feather-icon>
                    </b-button>
                    <b-tooltip :target="`check-${props.index}`">{{ $t('creator.approve') }}</b-tooltip>
  
                    <b-button variant="flat-secondary" :id="`reject-${props.index}`"  @click.stop="actionTableStatus('rejected', props.row.uuid)">
                      <feather-icon icon="XIcon" class="text-danger"></feather-icon>
                    </b-button>
                    <b-tooltip :target="`reject-${props.index}`">{{ $t('creator.decline') }}</b-tooltip>

                  </div>
                  <div v-else>
                    <b-badge :variant="props.row.status === 'approved' ? 'light-success' : props.row.status === 'rejected' ? 'light-danger' : 'light-secondary'">
                      {{ $t(`campaigns.${props.row.status}`) }}
                    </b-badge>
                  </div>
                  <b-button variant="flat-secondary" @click.stop="deletedCreator(props.row.uuid, props.row.influencer.username)" :class="['btn-delete-creator', {'ml-1': props.row.status !== 'pending'}]" :id="`delete-${props.index}`">
                    <feather-icon icon="TrashIcon"></feather-icon>
                  </b-button>
                  <b-tooltip :target="`delete-${props.index}`" triggers="hover">{{ $t('campaigns.action_filters.deleteBtn') }}</b-tooltip>

                  <b-button variant="flat-secondary" @click.stop="openNotes(props.row.uuid, props.row.influencer.username)" :class="['btn-notes-creator', {'ml-1': props.row.status !== 'pending'}]" :id="`table-notes-${props.index}`">
                    <feather-icon icon="FileTextIcon"></feather-icon>
                  </b-button>
                  <b-popover :target="`table-notes-${props.index}`" triggers="hover" placement="top">
                    {{ $t('campaigns.notes_popover') }}
                  </b-popover>
                </span>
              </template>
        
            </vue-good-table>

            <div class="container-loader-vue-good-table" v-if="loading_creators">
              <b-spinner class="spinner-loader"></b-spinner>
            </div>
          </div>
        
        </div>
        <b-col v-if="change_view_card && total_results >= 1">
          <div class="d-flex align-items-center justify-content-between flex-wrap w-100">
            <b-dropdown
              variant="flat-secondary"
              class="page-size-dropdown"
              :text="`${$t('campaigns.resultsPerPage')}: ${per_page}`"
            >
              <b-dropdown-item
                v-for="size in page_size_options"
                :key="size"
                @click="updatePerPage(size)"
              >
                {{ size }}
              </b-dropdown-item>
            </b-dropdown>
            <pagination-brandme-v2
              :total_rows="total_results"
              :current_page="current_page"
              :per_page="per_page"
              @update_current_page="updateCurrentPage"
            ></pagination-brandme-v2>
          </div>
        </b-col>

      </b-row>
    </b-card>
    <sidebar-search-new
      :open_sidebar="open_sidebar" 
      :key="update_sidebar" 
      :username="data_sidebar"
      :network="select_network"
      class="open-sidebar-search"
      v-if="open_sidebar"
    >
    </sidebar-search-new>

    <modal-brandme
      :show_modal="modal_notes"
      :no_footer="true"
      size="md"
      @hidden="modal_notes = false"
      :key="update_modal_notes"
    >
      <template #title>
        <h5 class="m-0">
          {{ $t('campaigns.notes') }}
          <span v-if="notes_influencer_name"> de {{ notes_influencer_name }}</span>
        </h5>
      </template>
      <template #body>
        <notes-modal
          :notes="notes_influencer"
          :total_count="notes_total_count"
          :current_page="notes_current_page"
          :page_size="5"
          @add_note="onAddNote"
          @edit_note="onEditNote"
          @delete_note="onDeleteNote"
          @change_page="onNotesPageChange"
        />
      </template>
    </modal-brandme>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BAvatar, BFormCheckbox, 
  BButtonGroup,
  BSpinner, 
  BButton, BImg, BSkeleton,
  BBadge,
  BTooltip,
  BLink,
  BDropdown,
  BDropdownItem,
  BPopover
} from 'bootstrap-vue'
import service from "@/services/campaign";
import config_env from '@/services/config';
import imgProfile from "@/assets/images/elements/error.png";
import { getIconWhite, getIconColor } from '@/libs/utils/icons';
import { getImageInfluencer, getMotivationalPhrase } from '@/libs/utils/others';
import { decimalFixed, getFormat, nameNetworks } from '@/libs/utils/formats';
import { isUrl, getAssetUrl, checkResourceExists } from '@/libs/utils/urls'
import { hasPermission } from '@/libs/utils/user';
import { VueGoodTable } from "vue-good-table";
import CsvFileIcon from '@/views/components/icons/CsvFileIcon.vue';
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  components: {
    filtersDropdown: () => import('@/views/components/brandme-ai/dropdowns/filtersDropdown.vue'),
    SidebarSearchNew: () => import('@/views/buscador/SidebarSearchNew.vue'),
    StatusInfluencer: () => import('@/views/campaings/statusInfluencer.vue'),
    BDropdown,
    BDropdownItem,
    BTooltip,
    BRow,
    BCol,
    BButtonGroup,
    BCard,
    BAvatar,
    BSpinner,
    BFormCheckbox,
    BButton,
    BImg,
    BSkeleton,
    BBadge,
    BLink,
    VueGoodTable,
    BPopover,
    ModalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    NotesModal: () => import('@/views/components/campaign/NotesModal.vue'),
    noResults: () => import('@/views/pages/proposals/stepper/noResults.vue'),
    ImageVerified: () => import('@/views/components/image/ImageVerified.vue'),
    paginationBrandmeV2: () => import('@/views/components/pagination/paginationBrandmeV2.vue')
  },
  props: {
    campaign_name: {
      type: String,
      default: ''
    },
    header_data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      getMotivationalPhrase,
      hasPermission,
      checkResourceExists,
      getAssetUrl,
      isUrl,
      decimalFixed,
      getImageInfluencer,
      getIconWhite,
      getIconColor,
      getFormat,
      nameNetworks,
      influencers_without_filter: [],
      influencers: [],
      checkedNames: [],
      change_filter: false,
      has_next_influencers: false,
      current_page: 1,
      per_page: 50,
      page_size_options: [10, 25, 50, 100],
      loading_creators: false,
      change_influencers: 0,
      interval_loading: null,
      total_results: 0,
      change_view_card: false,
      open_sidebar: false,
      update_sidebar: false,
      data_sidebar: '',
      select_network: 'instagram',
      networks_avaibles: [
        { value: 'instagram', text: 'Instagram' },
        { value: 'youtube', text: 'YouTube' },
        { value: 'tiktok', text: 'TikTok' },
        { value: 'twitter', text: 'Twitter' },
        { value: 'twitch', text: 'Twitch' }
      ],
      status_influencers: 'all',
      update_table: false,
      filter_category: '',
      filter_networks: [],
      modal_notes: false,
      notes_influencer: [],
      notes_influencer_name: '',
      notes_influencer_uuid: null,
      notes_current_page: 1,
      notes_total_count: 0,
      update_modal_notes: false,
      order_by_field: 'created_at',
      order_by_direction: 'desc'
    }
  },
  created() {
    this.loading_creators = true
    this.getInfluencers()
  },
  computed: {
    orderByFieldOptions() {
      const opts = this.$t('campaigns.orderByOptions');
      return Object.keys(opts).map(key => ({ value: key, label: opts[key] }));
    },
    orderByParam() {
      return this.order_by_direction === 'desc' ? `-${this.order_by_field}` : this.order_by_field;
    },
    influencerStatusImage() {
      if (this.loading_creators) return null;

      const images = [
        { status: 'all', src: require('@/assets/images/elements/campaign/all.png') },
        { status: 'pending', src: require('@/assets/images/elements/campaign/pending.png') },
        { status: 'approved', src: require('@/assets/images/elements/campaign/approved.png') },
        { status: 'rejected', src: require('@/assets/images/elements/campaign/rejected.png') },
      ];

      return images.find(item => item.status === this.status_influencers) || null;
    },
    actions_options() {
      return [
        {
          value: 'select_all',
          text: 'actionSelectAll',
          icon: 'CheckSquareIcon',
          disabled: this.disabledUpdateCampaign(),
          view_drop_item: true,
        },
        {
          value: 'unselect_all',
          text: 'actionRemoveSelection',
          icon: 'XSquareIcon',
          disabled: this.disabledUpdateCampaign(),
          view_drop_item: true,
        },
        {
          value: 'export_proporsals',
          text: 'export_proporsals',
          customIcon: CsvFileIcon,
          disabled: false,
          view_drop_item: true,
        },
        {
          value: 'exportSummary',
          text: 'exportSummary',
          icon: 'ShareIcon',
          disabled: this.disabledUpdateCampaign() || this.checkedNames.length === 0,
          view_drop_item: true,
        },
        {
          value: 'proposalBtn',
          text: 'proposalBtn',
          icon: 'UserMinusIcon',
          disabled: this.disabledUpdateCampaign() || this.checkedNames.length === 0,
          view_drop_item: true,
        },
        {
          value: 'approveBtn',
          text: 'approveBtn',
          icon: 'UserCheckIcon',
          disabled: this.disabledUpdateCampaign() || this.checkedNames.length === 0,
          view_drop_item: true,
        },
        {
          value: 'rejectBtn',
          text: 'rejectBtn',
          icon: 'UserXIcon',
          disabled: this.disabledUpdateCampaign() || this.checkedNames.length === 0,
          view_drop_item: true,
        },
        {
          value: 'deleteBtn',
          text: 'deleteBtn',
          icon: 'UserMinusIcon',
          disabled: this.disabledUpdateCampaign() || this.checkedNames.length === 0,
          view_drop_item: true,
        }
      ];
    }
  },
  methods: {
    onSortChanged({ field, direction }) {
      this.order_by_field = field;
      this.order_by_direction = direction;
      this.current_page = 1;
      this.getInfluencers();
    },
    openNotes(influencer_uuid, name) {
      this.notes_influencer_uuid = influencer_uuid;
      this.notes_current_page = 1;
      service.getNotesInfluencerCampaign(influencer_uuid, 1, 5).then(response => {
        this.notes_influencer = response.results || [];
        this.notes_total_count = response.count || 0;
        this.notes_influencer_name = name || '';
        this.modal_notes = true;
        this.update_modal_notes = !this.update_modal_notes;
      });
    },
    onNotesPageChange(page) {
      this.notes_current_page = page;
      service.getNotesInfluencerCampaign(this.notes_influencer_uuid, page, 5).then(response => {
        this.notes_influencer = response.results || [];
        this.notes_total_count = response.count || 0;
      });
    },
    onAddNote(note_text) {
      service.addCampaignInfluencerNote(this.notes_influencer_uuid, note_text)
        .then((response) => {
          this.notes_influencer.unshift(response)
          this.notes_total_count += 1
          const influencer = this.influencers.find(i => i.uuid === this.notes_influencer_uuid)
          if (influencer) influencer.notes = this.notes_influencer
        })
        .catch(() => this.errorMessage())
    },
    onEditNote({ uuid, note }) {
      service.updateCampaignInfluencerNote(uuid, note)
        .then((response) => {
          const idx = this.notes_influencer.findIndex(n => n.uuid === uuid)
          if (idx !== -1) this.$set(this.notes_influencer, idx, response)
        })
        .catch(() => this.errorMessage())
    },
    onDeleteNote(uuid) {
      service.deleteCampaignInfluencerNote(uuid)
        .then(() => {
          this.notes_influencer = this.notes_influencer.filter(n => n.uuid !== uuid)
          this.notes_total_count -= 1
        })
        .catch(() => this.errorMessage())
    },
    onActionSelected(action) {
      const action_on = {
        select_all: this.selectAll,
        unselect_all: this.unselectAll,
        export_proporsals: this.exportProposals,
        exportSummary: this.exportCampaignSummaries,
        proposalBtn: this.pendingUsers,
        approveBtn: this.approvedUsers,
        rejectBtn: this.rejectedUsers,
        deleteBtn: this.removedUsers,
      };

      if (action_on[action]) action_on[action]();
    },
    updated_campaign() {
      this.$emit('update_header_campaign');
    },
    updateCurrentPage(page) {
      this.current_page = page;
    },
    updatePerPage(size) {
      if (this.per_page === size) return;

      this.per_page = size;
      if (this.current_page === 1) {
        this.getInfluencers();
      } else {
        this.current_page = 1;
      }
    },
    onFiltersChanged({ query, type, networks, status }) {
      this.query = query;
      this.filter_category = type === 'all' ? '' : type;
      this.filter_networks = networks;
      this.status_influencers = status === 'production' ? 'producing' : status === 'proposals' ? 'all' : status;

      const params = [];
      if (type && type !== 'all') params.push(`category=${type}`);
      if (networks && networks.length > 0) {
        networks.forEach(net => {
          params.push(`networks=${net}`);
        });
      }

      this.filters_params = params.length ? `&${params.join('&')}` : '';
      this.getInfluencers();
    },
    openSummaryProfile(item) {
      this.data_sidebar = item.username; 
      this.select_network = item.network;
      this.open_sidebar = true;
      this.update_sidebar = !this.update_sidebar;
    },
    getRowClass(row) {
      if (this.checkedNames.includes(row.uuid)) {
        return 'row-bg-selected';
      }
      return '';
    },
    selectionChanged(data) {
      this.checkedNames = data.selectedRows
    },
    openSidebarAddInfluencer() {
      this.$emit('openSidebar');
    },
    
    getInfluencers() {
      this.loading_creators = true;
      const page_size = !this.change_view_card ? 20 : this.per_page;
      service.getCampaignInfluencers(this.$route.params.uuid, this.current_page, page_size, this.status_influencers, this.filters_params, this.query, this.orderByParam)
        .then(response => {
          this.total_results = response.count;
          this.loading_creators = false;
          if (!this.change_view_card) {
            this.influencers_without_filter = response.results;
            this.influencers = response.results;
          } else {
            this.influencers_without_filter = response.results;
            this.influencers = response.results;
          }
          
          this.has_next_influencers = response.next !== null;
        });
    },
    getScrollInfiniteInfluencers() {
      const page_size = 20;
      if ((this.influencers.length <  this.total_results) || this.influencers.length === 0) {
        this.loading_creators = true;
        service.getCampaignInfluencers(this.$route.params.uuid, this.current_page, page_size, this.status_influencers, this.filters_params)
          .then(response => {
            this.total_results = response.count;
            this.loading_creators = false;
            this.influencers_without_filter = [...this.influencers_without_filter,...response.results,];
            this.influencers = [...this.influencers,...response.results,];
            this.has_next_influencers = response.next !== null;
          });
      }
    },
    getUsername(influencer) {
      if (influencer.network === 'youtube') return influencer.name
      return influencer.username
    },
    replaceInsta(event, username, network) {
      if (network.toLowerCase() === 'instagram') {
        this.$http.get(`${config_env.urlCore}/api/v1/finder/profile/image/${username}`)
          .then(function(response) {
            const img_url = isUrl(response.data.response.image) ? response.data.response.image : getAssetUrl(response.data.response.image);
            checkResourceExists(img_url).then(function(result) {
              if (!result) {
                event.target.src = imgProfile;
              } else {
                event.target.src = img_url;
              }
            });

          })
          .catch(() => {
            event.target.src = imgProfile;
          });
      } else event.target.src = imgProfile;
    },
    updateInfluencer(influencer_updated) {
      this.$emit('update_header_data', influencer_updated.campaign_header);
      this.influencers = this.influencers.map(i => {
        return i.uuid === influencer_updated.uuid ? influencer_updated : i;
      });
    },
    engagement (num) {
      let result = ''
      if (num < 1000) {
        result = num
      }
      if (num > 999) {
        result = `${(Math.round(num / 100) / 10)} K`
      }
      if (num > 999999) {
        result = `${(Math.round(num / 100000) / 10)} M`
      }
      if (num > 999999999) {
        result = `${(Math.round(num / 100000000) / 10)} B`
      }
      return result
    },
    categoryFilterAll () {
      this.influencers_without_filter = []
      this.filter_category = ''
      this.current_page = 1
      this.loading_creators = true
      this.getInfluencers()
      this.influencers = this.influencers_without_filter
      this.change_filter = !this.change_filter
    },
    categoryFilter (category) {
      this.loading_creators = true
      this.influencers_without_filter = []
      this.current_page = 1
      this.filter_category = `&category=${category}`
      this.getInfluencers()
      this.change_filter = !this.change_filter
      this.influencers = []
      this.influencers_without_filter.forEach(influencer => {
        if (influencer.influencer.calculate_category === category) {
          this.influencers.push(influencer)
        }
      })
    },
    actionTableStatus(action, uuid) {
      if (this.disabledUpdateCampaign()) return;
      service.influencerAction(this.$route.params.uuid, [uuid], action)
        .then(() => {
          this.removedInflu();
          if (action === 'approved') this.approvedInflu();
          if (action === 'rejected') this.rejectedInflu();
          this.$emit('update_counter_header');
          this.$emit('update_header_campaign');

          const index = this.influencers.findIndex(i => i.uuid === uuid);
          if (index !== -1) {
            this.influencers[index].status = action;
          }
        })
        .catch(() => {
          this.errorMessage()
        })
    },
    selectAll () {
      if (this.disabledUpdateCampaign()) return;
      if (this.change_view_card && (this.checkedNames.length === 0 || this.checkedNames.length < this.influencers.length)) {
        this.$nextTick(() => {
          const selectAllCheckbox = document.querySelector(
            "table thead tr th:first-child input[type='checkbox']"
          );
          if (selectAllCheckbox) {
            selectAllCheckbox.click();
          }
        });
      } else {

        this.checkedNames = []
        this.influencers.forEach(i => {
          this.checkedNames.push(i.uuid)
        })
      }
    },
    unselectAll() {
      if (this.change_view_card && this.checkedNames.length > 0) {
        this.$nextTick(() => {
          const selectAllCheckbox = document.querySelector(
            "table thead tr th:first-child input[type='checkbox']"
          );
          if (selectAllCheckbox) {
            selectAllCheckbox.click();

            if (this.checkedNames.length !== this.influencers.length) selectAllCheckbox.click();
          }
        });
      } else {
        this.checkedNames = []
      
      }
    },
    statusApproved () {
      this.$swal({
        title: this.$t('campaigns.approveInfluencer'),
        text: this.$t('campaigns.influencerSuccess'),
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary'
        },
        buttonsStyling: false,
        heightAuto: false
      })
    },
    pendingUsers () {
      if (this.disabledUpdateCampaign()) return;
      this.$swal({
        title: this.$t('campaigns.pendingCreator'),
        text: this.$t('campaigns.pendingSuccess'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.realty.accept'),
        cancelButtonText: this.$t('campaigns.realty.cancel'),
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false,
        heightAuto: false

      }).then(result => {
        if (result.value) {
          this.statusUsers('pending')
        }
      })
    },
    approvedUsers () {
      if (this.disabledUpdateCampaign()) return;
      this.$swal({
        title: this.$t('campaigns.approveCreator'),
        text: this.$t('campaigns.approveSuccess'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.realty.accept'),
        cancelButtonText: this.$t('campaigns.realty.cancel'),
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false,
        heightAuto: false

      }).then(result => {
        if (result.value) {
          this.statusUsers('approved')
        }
      })

    },
    rejectedUsers () {
      if (this.disabledUpdateCampaign()) return;
      this.$swal({
        title: this.$t('campaigns.textConfirmRejectCreators'),
        text: this.$t('campaigns.textRejectCreators'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.msjConfirmRejectCreators'),
        cancelButtonText: this.$t('campaigns.msjCancel'),
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false,
        heightAuto: false
      }).then(result => {
        if (result.value) {
          this.statusUsers('rejected')
        }
      })
    },
    removedUsers () {
      if (this.disabledUpdateCampaign()) return;
      this.$swal({
        title: this.$t('campaigns.textConfirmCreators'),
        text: this.$t('campaigns.textCreators'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.msjConfirmCreators'),
        cancelButtonText: this.$t('campaigns.msjCancel'),
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false,
        heightAuto: false
      }).then(result => {
        if (result.value) {
          this.statusUsers('removed')
        }
      })
    },
    statusUsers (status) {
      service.influencerAction(this.$route.params.uuid, this.checkedNames, status)
        .then((response) => {
          this.change_influencers += 1
          
          this.checkedNames.forEach(influencer_uuid => {
            const influencer = this.influencers.find(influ => influ.uuid === influencer_uuid)
            if (influencer) {
              if (status !== 'removed') {
                influencer.status = status
              } 
            }
          })
          if (status === 'approved') {
            this.$emit('update_header_data', response.results[0].campaign_header)
            this.$emit('update_header_campaign');
            this.checkedNames = [];
            this.approvedInflu()
          }
          if (status === 'pending') {
            this.$emit('update_header_data', response.results[0].campaign_header)
            this.$emit('update_header_campaign');
            this.checkedNames = [];
          }
          if (status === 'rejected') {
            this.$emit('update_header_data', response.results[0].campaign_header)
            this.rejectedInflu()
            this.checkedNames = [];
          }
          if (status === 'removed') {
            this.removedInflu()
            this.influencers = this.influencers.filter(i => !this.checkedNames.includes(i.uuid));
            this.$emit('update_counter_header')
            this.$emit('update_header_campaign');
            this.checkedNames = [];
          } else {
            this.$emit('childStatus', status)
          }
        })
        .catch(() => {
          this.errorMessage()
        })
    },
    approvedInflu () {
      this.$swal({
        title: this.$t('campaigns.approveInfluencers'),
        text: this.$t('campaigns.influencersSuccess'), 
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary'
        },
        buttonsStyling: false,
        heightAuto: false
      })
    },
    rejectedInflu () {
      this.$swal({
        title: this.$t('campaigns.rejectInfluencers'),
        text: this.$t('campaigns.textReject'),
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary'
        },
        buttonsStyling: false,
        heightAuto: false
      })
    },
    removedInflu () {
      this.$swal({
        title: this.$t('campaigns.deleteInfluencers'),
        text: this.$t('campaigns.textDelete'),
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-success'
        },
        buttonsStyling: false,
        heightAuto: false
      })
    },
    deletedCreator (uuid, name) {
      if (this.disabledUpdateCampaign()) return;
      this.$swal({
        title: `${this.$t('campaigns.textConfirm')} ${name} ?`,
        text: this.$t('campaigns.textRemove'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('campaigns.msjConfirm'),
        cancelButtonText: this.$t('campaigns.msjCancel'),
        customClass: {
          confirmButton: 'btn confirm-button',
          cancelButton: 'btn btn-outline-secondary ml-1'
        },
        buttonsStyling: false,
        heightAuto: false
      }).then(result => {
        if (result.value) {
          service.influencerAction(this.$route.params.uuid, [uuid], 'removed')
            .then(() => {
              this.removedInflu()
              this.influencers = this.influencers.filter(i => i.uuid !== uuid);
              this.checkedNames = this.checkedNames.filter((id) => id !== uuid);
              this.influencers.forEach(info => {
                this.checkedNames.forEach(exp => {
                  if (info.uuid === exp.uuid) {
                    info.vgtSelected = true;
                  }
                });
              });
              console.log(this.exportable)
              console.log(this.influencers)
              this.$emit('update_counter_header')
              this.$emit('update_header_campaign');
            })
            .catch(() => {
              this.errorMessage()
            })
        }
      })
    },
    errorMessage () {
      this.$swal({
        title: this.$t('campaigns.errormessage'),
        text: this.$t('campaigns.tryAgainLater'),
        icon: 'warning',
        customClass: {
          confirmButton: 'btn btn-danger'
        },
        buttonsStyling: false,
        heightAuto: false
      })
    },
    disabledUpdateCampaign() {
      return !hasPermission('change_campaign')
    },
    exportCampaignSummaries() {
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);

      const selectedInfluencers = this.influencers
        .filter(influencer => this.checkedNames.includes(influencer.uuid))
        .map(influencer => ({
          network: influencer.influencer.network,
          username: influencer.influencer.username,
        }));

      service.createExportCampaignSummaries(this.$route.params.uuid, selectedInfluencers)
        .then(() => {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: "top-right",
              props: {
                icon: 'LinkIcon',
                title: 'Exportación creada',
                variant: "success",
                text: 'Te avisaremos cuando la exportación esté lista para descargar.',
              }
            })
          })

          clearInterval(this.interval_loading)
          this.$vs.loading.close()
        })
        .catch(() => {
          clearInterval(this.interval_loading)
          this.$vs.loading.close()
        })
    },
    exportProposals() {
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      service.exportProposals(this.$route.params.uuid, this.checkedNames)
        .then(response => {
          const downloadLink = document.createElement("a");
          const blob = new Blob(["\ufeff", response]);
          const url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = `Influencers ${this.campaign_name}.csv`;

          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);

          clearInterval(this.interval_loading)
          this.$vs.loading.close()
        })
        .catch(() => {
          clearInterval(this.interval_loading)
          this.$vs.loading.close()
        })
    },
    getClasses(influencer) {
      if (influencer.engagement_rate > 0) return 'row mt-3 container-er-followers'
      return 'd-flex justify-content-center align-items-center mt-3'
    }
  },
  watch: {
    current_page() {
      if (this.change_view_card) {
        this.getInfluencers();
      }
    },
    change_view_card() {
      this.checkedNames = [];
      this.current_page = 1;
      this.getInfluencers();
    },
  }
}
</script>
<style scoped lang="scss">
.show-dropdown-views {
  display: none;
  @media (min-width: 992px) and (max-width: 1250px) {
    display: block;
  }
}

.hide-dropdown-views {
  @media (min-width: 992px) and (max-width: 1250px) {
    display: none;
  }
}

@media (max-width: 991px) {
  .w-md-100 {
    width: 100%;
  }
}

.btn-delete-creator:focus {
  background: transparent;
}
.icon-squad-network-avatar {
  width: 20px !important;
}
.container-loader-vue-good-table {
  background-color: rgba(255, 255, 255, 0.703);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner-loader {
    width: 30px;
    height: 30px;
    color: #828282;
  }
}
.main-container-cell-id {
  width: 20px !important;
  height: 20.3px;
}
.cursor-pointer {
  cursor: pointer;
}
.h-min-empty {
  min-height: 400px;
}
.mb-05 {
  margin-bottom: 0.5em;
}
.card-skeleton {
  background-color: #fff;
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    border-radius: .4rem;
  }
  .skeleton {
    &.profile-avatar {
      width: 200px;
      height: 200px;
      border-radius: 100%;
    }
  }
}
.mb-7 {
  margin-bottom: 7em;
}
.all-results-loaded-text {
  color: #7F7F7F;
  font-size: 0.9rem;
  padding: 1.5rem 0;
}
.button-outline-header {
  background: white;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 4px;
  padding: 10px;
  margin-left: 10px;

  &:active {
    background: rgb(243, 243, 243);
  }
}
.ml-05 {
  margin-left: 0.5em;
}
.body-button-center{
  position: relative;
  background-color: #e9ecef;
  padding: .25rem .25rem;
  border-radius: .375rem;

  @media (max-width: 991.98px) {
    width: 100%;
  }
}
.button-outline-header-grid-active {
  background: white;
  padding: 5px 10px;
  border-radius: 6px !important;
}

.button-outline-header-grid-no-active {
  background: transparent;
  padding: 5px 10px;
  border: none;
}
.gray-color-text {
  color: #8490a4;
  font-family: 'avenir-medium';
}
.avatar-absolute-net-influecer-list {
  position: absolute;
  left:4px 
}
</style>
<style lang="scss">

.vgt-table {
  width: 100%
}
.vgt-table-influencers-inner-campaign {
  overflow: visible !important;
}
.vgt-table-influencers-inner-campaign tbody tr:hover {
  cursor: pointer;
  background-color: rgb(240, 240, 240) !important;
  transition: all 200ms;
}
.row-bg-selected {
  cursor: pointer;
  background-color: rgb(240, 240, 240) !important;
  transition: all 200ms;
}

.aditional-width {
  min-width: 320px;
}
#table-proposals-influencers {
  padding: 1em;
  width: 100%;
}
#table-proposals-influencers td {
  border-bottom: 1px solid #eff3f6;
}
#table-proposals-influencers tr {
  background-color: white;
}
#table-proposals-influencers tr:hover {
  background-color: #F5F8FA;
  cursor: pointer;
  transition: all 100ms;
}
.checkbox-table-searcher {
  display: none !important;
}
#table-proposals-influencers tr:hover .checkbox-table-searcher {
  display: block !important;
}
#table-proposals-influencers tr:hover .id-table-searcher {
  display: none;
}
  @media (max-width: 575.98px) {
    .card-all-users-profiles .profile-image .b-avatar {
      width: 140px !important;
      height: 140px !important;
    }
  }
  .without-border {
    border: none !important;
  }

  .socialnet-campaigns {
    font-size: 1.3em;
    position: absolute;
    left: 60%;
    bottom: 0;
    background: white;
    z-index: 9;
    padding: 2%;
    border-radius: 50%;
  }
  @media(min-width:2000px) {
    .socialnet-campaigns {
      left: 55%;
    }
  }
  @media(max-width: 992px) {
    .socialnet-campaigns {
      left: 54%;
    }
  }
  .card-all-users-profiles {
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1) !important;
    height: 95%;

    @media (max-width: 575.98px) {
      .b-avatar.avatar-xl,
      .b-avatar[style*="width: 200px"],
      .b-avatar[style*="width:200px"] {
        width: 140px !important;
        height: 140px !important;
      }
    }
  }
  .img-200 {
    width: 200px;
    @media (max-width: 575.98px) {
      width: 140px;
    }
  }
  .h-450 {
    /* height: 1280px; */
    overflow: scroll;
    overflow-x: hidden
  }
  .notes-creator {
    right: 20px;
    top: 0;
    z-index: 9
  }
  .delete-creator {
    right: 0;
    top: 0;
    z-index: 9
  }
  .square-20 {
    width: 20px;
    height: 20px;
  }
  .w-5rem {
    width: 5rem;
    height: 5rem;
  }
</style>
